import React, {useMemo, useCallback, useState, useEffect} from "react"
import {useSelector, useDispatch} from "react-redux"
import {Transition} from "react-transition-group"

import LeftWorkHeader from "../LeftWorkHeader/LeftWorkHeader"
import ColorBtn from "./ColorBtn"

import {
  setProduct2dBaseColor,
  setLeftWorkAreaState,
  setProduct2d,
} from "../../../redux/actions/product2dActions"

import "./leftworkcolor.scss"

import {colors as textColors} from "../../../constants/utils"

const transitionStyles = {
  entering: {opacity: 0},
  entered: {opacity: 1, position: "relative"},
  exiting: {opacity: 0},
  exited: {opacity: 0},
}
/**
 * Button on left panel. This button toggle menu for work with text and images
 * @component
 * @param {object} props
 * @param {boolean} props.active=false - color winndow state
 * @param {boolean} props.textColor=false - flag for text color
 *
 * @example
 * const textColor = false
 * const active = false
 *
 * return (
 *  <LeftWorkColor
 *  textColor={textColor}
 *  active={active}
 *  />
 * )
 */

const LeftWorkColor = props => {
  const {active, textColor = false} = props
  const dispatch = useDispatch()
  const product2d = useSelector(state => state.product2d)
  const makFabric = useSelector(state => state.makFabric)
  const products = useSelector(({ products }) => products);

  const [colors, setColors] = useState([])

  const [textC, setTextC] = useState({
    color: "#000000",
    label: "Black",
  })

  const [garmentC, setGarmentC] = useState({})

  const { sizeColorMapping } = useSelector(({ products }) => products);

  useEffect(() => {

    if (textColor) {
      setColors(textColors)
    } else if (sizeColorMapping && product2d) {
      console.log(product2d.size)
      setColors(sizeColorMapping[product2d.size] || [])
      setGarmentC({
        color: product2d.color,
        label: product2d.colorName
      })
    }

  }, [sizeColorMapping, product2d.size, textColor])

  useEffect(()=>{
    if(!textColor ){
     const garmentColor =  colors.find(item=>item.color === product2d.color);
     garmentColor && setGarmentC(garmentColor)
     makFabric && makFabric.setBaseColor(product2d.color)
    }
  },[product2d.color])

  const handleSelectColor = useCallback(
    e => {
      if (!textColor) {
        dispatch(
          setProduct2dBaseColor({
            color: e.target.dataset.color,
            label: e.target.dataset.value,
          }),
        )

        setGarmentC({
          color: e.target.dataset.color,
          label: e.target.dataset.value,
        })

        const newSelection = products.skuArray.find(item => {
          return (item.color === e.target.dataset.color) && (item.size === product2d.size)
        })

        const selection = {
          ...product2d,
          variationSKU: newSelection.sku,
          price: newSelection.price,
          color: e.target.dataset.color
        }

        console.log(selection)

        dispatch(setProduct2d(selection))

      } else {
        makFabric.setTextColor(
          makFabric.getSelectedText(),
          e.target.dataset.color,
        )
        setTextC({
          color: e.target.dataset.color,
          label: e.target.dataset.value,
        })
      }
    },
    [dispatch, makFabric, textColor, products, product2d],
  )

  const renderColors = useMemo(
    () =>
      colors.map(item => {
        console.log('--color----->' + item.colorName+','+garmentC?.label)
        return <ColorBtn
          key={item.color}
          color={item.color}
          title={item.colorName}
          active={
            !textColor
              ? garmentC?.color === item.color
              : textC?.color === item.color
          }
          handler={handleSelectColor}
        />
      }),
    [colors, handleSelectColor, garmentC?.color, textC?.color, textColor],
  )

  const backToEdit = () => {
    dispatch(setLeftWorkAreaState("EDIT_TEXT"))
  }

  useEffect(() => {
    if (makFabric) {
      makFabric.getSelectedText() &&
        setTextC(
          colors.find(item => item.color === makFabric.getSelectedText()),
        )
    }
  }, [makFabric])

  return (
    <Transition
      in={active}
      timeout={200}
      unmountOnExit={true}
      mountOnEnter={true}
    >
      {state => (
        <div
          className="leftWorkColorContainer"
          style={{
            ...transitionStyles[state],
          }}
        >
          <LeftWorkHeader
            title={textColor ? "Text color" : "Choose Base Color"}
            activeHandler={textColor}
            handler={backToEdit}
          />
          <div className="leftWorkColorContent">
            <div className="leftWorkColorTitle">
              <span>{textColor ? "Text color" : "Selected Color:"}</span>
              <div
                className="leftWorkColorTitle_color"
                style={{
                  backgroundColor: textColor
                    ? textC.color
                    : garmentC.color,
                }}
              ></div>
              <span>{!textColor ? garmentC.label : textC.label}</span>
            </div>
            <div className="leftWorkColorColorsContainer">{renderColors}</div>
          </div>
        </div>
      )}
    </Transition>
  )
}

export default LeftWorkColor
